import React from 'react';

const AdSpace = () => {
  return (
    /* Removed max-w-300px here because the parent Grid should control width */
    <div className="w-full flex flex-col gap-5 sticky top-24">
      <div className="bg-slate-50 border border-slate-200 rounded-3xl p-5 text-center min-h-[600px] flex flex-col items-center justify-center transition-all hover:border-blue-200">
        
        <p className="text-[10px] text-slate-400 mb-4 font-bold uppercase tracking-widest">
          Advertisement
        </p>

        <div className="w-full grow flex items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-white/50 text-slate-300 text-sm italic">
          {/* Ad Placeholder */}
          <div className="flex flex-col items-center gap-2">
            <svg className="w-8 h-8 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>Google Ad Placement</span>
          </div>
          
          {/* When you're ready for production:
            <ins 
              className="adsbygoogle"
              style={{ display: 'block', width: '100%', height: '100%' }}
              data-ad-client="ca-pub-xxxxxxxxxxxxxxxx"
              data-ad-slot="xxxxxxxxxx"
            ></ins> 
          */}
        </div>

      </div>
    </div>
  );
};

export default AdSpace;